module.exports = {"431024100":"珠泉镇","431024102":"塘村镇","431024103":"袁家镇","431024104":"行廊镇","431024106":"龙潭镇","431024107":"石桥镇","431024108":"坦坪镇","431024110":"广发镇","431024111":"晋屏镇","431024201":"普满乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431024.json
// module id = 1732
// module chunks = 0